import {
	NumberInput as BaseNumberInput,
	type NumberInputProps,
} from "@heroui/react";

import { useFieldContext, useLanguage } from "@onesolution/hooks";

export function NumberInput(props: NumberInputProps) {
	const field = useFieldContext<number>();
	const { t } = useLanguage();

	return (
		<BaseNumberInput
			isInvalid={!field.state.meta.isValid}
			size="sm"
			id={field.name}
			name={field.name}
			aria-label="number"
			value={field.state.value}
			onBlur={field.handleBlur}
			errorMessage={t("message.required")}
			onValueChange={(v) => field.handleChange(v)}
			{...props}
		/>
	);
}
